// extracted by mini-css-extract-plugin
export default {"btnStyle":"Button_btnStyle__kEnGX","complimentary":"Button_complimentary__nTKF3","secondary":"Button_secondary__3cHjW","sm":"Button_sm__VBfWp"};